import {PicTypes, ServerURLs} from './enumUtils';
import {
    convertHoursFromMilitaryTime,
    convertMinutesInto2CharString,
    addHourLabelForDescription,
} from "./dateTimeUtils";
import moment from "moment/moment";

export const VIBO_SERVER_URL           = ServerURLs.production;
// export const VIBO_SERVER_URL        = ServerURLs.localhost;
// export const VIBO_SERVER_URL        = ServerURLs.staging;

export const VIBO_SITE_URL          = "https://web.vibo.io";
export const VIBO_MARKETING_SITE    = "https://vibo.io";

const HTTP = "http";
const HTTPS = "https";

export function swapHttpToHttps(url){
    if (url && !(url.includes(HTTPS)) && url.includes(HTTP)) {
        return url.replace(HTTP, HTTPS);
    }
    return url;
}

let plFormUrl = `${VIBO_SITE_URL}/planningForm/`;
if(VIBO_SERVER_URL === ServerURLs.localhost){
    plFormUrl = `http://127.0.0.1:8080/planningForm/`; // to work locally with planning form links
}

const availableRegionsList = ["en_US", "he_IL", "la_ES", "xx_XX"];

const countriesList =
    ["United States","United Kingdom","Afghanistan","Albania","Algeria","Angola","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","The Bahamas","Bahrain","Bangladesh","Barbados","Belarus",
        "Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon",
        "Canada","Central African Republic","Chad","Chile","Republic of China","Colombia","Congo","Cook Islands","Costa Rica","Cote d'Ivoire","Croatia","Cuba","Cyprus","Czech Republic",
        "Denmark","Dominican Republic","Ecuador","Egypt","El Salvador","Eritrea","Estonia","Ethiopia","Faroe Islands","Fiji","Finland","France","Gabon","Georgia","Germany",
        "Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guinea","Haiti","Honduras","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland",
        "Israel","Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya","South Korea","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya",
        "Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Martinique","Mauritius",
        "Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco","Mozambique","Myanmar","Namibia","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria",
        "Norway","Oman","Pakistan","Panama","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Romania","Russia","Rwanda","Samoa","Saudi Arabia","Senegal",
        "Serbia","Sierra Leone","Singapore","Slovakia","Slovenia","Somalia","South Africa","Spain","Sri Lanka","Sudan","Sweden","Switzerland","Syria","Taiwan","Tanzania",
        "Thailand","Togo","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay",
        "Uzbekistan","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe"];

const EVENT_DEFAULT_LENGTH_IN_HOURS = 5;

export function getCountryList() {
    return countriesList;
}

export function structureTimeForCalendarEventDescription (label, dateType, characterSeparator, newLine){
    return (
        label
        + characterSeparator
        + 'Time: '
        + characterSeparator
        + convertHoursFromMilitaryTime(dateType)
        + ':'
        + convertMinutesInto2CharString(dateType)
        + characterSeparator
        + addHourLabelForDescription(dateType)
        + newLine
    );
}

export function addContactsToCalendarDescription (contactsList, characterSeparator, newLine){
    let description = '';
    if (contactsList) {
        (contactsList).forEach(function(contact){
            description += `${getContactFullName(contact)}`;
            description += contact.email ? `,${characterSeparator}${contact.email}` : '';
            description += contact.phone ? `,${characterSeparator}${contact.phone}` : '';
            description += newLine
        });
        description += '---';
        description += newLine;
    }
    return description;
}

let getFinalEndDate = (arrivalDate, startDate, endDate) =>
    (endDate || (moment(arrivalDate || startDate).add(EVENT_DEFAULT_LENGTH_IN_HOURS, 'h')).toDate());


export function ifPassingMidnightAddDay (arrivalDate, startDate, endDate) {
    let finalStartDate = (arrivalDate || startDate);
    let finalEndDate = getFinalEndDate(arrivalDate, startDate, endDate);
    // end date (time) is smaller than start date (time), meaning it'll finish the next day
    if(finalEndDate < finalStartDate){
        finalEndDate = (moment(finalEndDate).add(1, 'd')).toDate();
    }
    return finalEndDate;
}

export function createCalendarDescription (arrivalDate, startDate, endDate, contactsList, characterSeparator, newLine){
    let description = '';
    let endDateType = ifPassingMidnightAddDay(arrivalDate, startDate, endDate);
    description += (contactsList) ? 'Contact List:' + newLine : '';
    description += addContactsToCalendarDescription(contactsList, characterSeparator, newLine);
    description += (arrivalDate ? structureTimeForCalendarEventDescription('Arrival', arrivalDate, characterSeparator, newLine) : '');
    description += structureTimeForCalendarEventDescription('Start', startDate, characterSeparator, newLine);
    description += structureTimeForCalendarEventDescription('End', endDateType, characterSeparator, newLine);
    description += newLine;
    return description;
}

export function getAvailableRegionsList() {
    return availableRegionsList;
}

export function getDefaultCountryLocale() {
    return "United States";
}

export function getPlanningFormUrl() {
    return plFormUrl;
}

export function isMobileDevice() {
    return (window.innerWidth <= 760);
}

export function isProduction() {
    return (process.env.NODE_ENV === 'production');
}

export function getRatioTextId(picType) {
    switch(picType){
        case PicTypes.COVER:
        case PicTypes.TEMPLATE:
        case PicTypes.EVENT_COVER:
            return "gallery.dropFilesAreaText_recSizes_16_9";
        default:
            return "gallery.dropFilesAreaText_recSizes_1_1";
    }
}

export function logElapsedTime(start, inSeconds) {
    let timeDiff = new Date() - start;
    timeDiff /= (inSeconds?1000:1);
    console.log(Math.round(timeDiff) + inSeconds?' seconds': ' miliseconds');
}

export function isScannerOnTestMode(uploadedFilesDataTest){
    return (uploadedFilesDataTest && uploadedFilesDataTest.onTestData);
}

export function openCenteredPopupWindow(url, title, w, h) {
    const wLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const wTop = window.screenTop ? window.screenTop : window.screenY;

    const left = wLeft + (window.innerWidth / 2) - (w / 2);
    const top = wTop + (window.innerHeight / 2) - (h / 2);
    return window.open(url, title, 'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
}

let getContactFullName = function(contact) {
    let contactFullName = '';
    if(contact){
        if(contact.firstName){
            contactFullName = contact.firstName + (contact.lastName?(' ' + contact.lastName): '');
        }
        else{ // backwards compatibility when there wasn't first + last name only name
            contactFullName = contact.name;
        }
    }
    return contactFullName;
};

export {getContactFullName}



// WEBPACK FOOTER //
// ./src/utils/generalUtils.js